export default function($log) {
  'ngInject';

  const vm = this;

  vm.refresh = () => {
    $log.debug(`Refreshing ${vm.name}`);
    vm.reload()();
  };
}



// WEBPACK FOOTER //
// ./src/app/components/error/controller.js